<template>
  <div
    v-if="user"
    class="tab-pane"
    id="pills-setting"
    role="tabpanel"
    aria-labelledby="pills-setting-tab"
    v-bind:class="$route.name == 'Setting' ? 'active' : ''"
  >
    <!-- Start Settings content -->
    <div class="overflow-auto">
      <div class="user-profile-img">
        <!--
        TODO: @hamid = Ask Farzana to Add Photo?
        <img
          src="assets/images/small/logo_newabc-orange.jpg"
          class="profile-img profile-foreground-img"
          style="height: 160px"
          alt="logo_newabc-orange"
        />
        -->
        <div class="h5 p-4 ps-md-5 bg-primary text-white">
          Networking the Educational World:<br />Across Boundaries dor
          Community-building.
        </div>
        <div class="overlay-content bg-dark bg-opacity-25"></div>
      </div>

      <div
        class="text-center p-3 p-lg-4 border-bottom pt-2 pt-lg-2 mt-n5 position-relative"
      >
        <div class="mb-3 profile-user">
          <img
            v-if="user.profile_image != 'non'"
            :src="user.profile_image"
            class="rounded-circle avatar-lg img-thumbnail user-profile-image"
            v-alt="user.username"
          />
          <img
            v-else
            :src="
              $store.state.config.frontpoint + 'storage/default-user-photo.png'
            "
            class="rounded-circle avatar-lg img-thumbnail user-profile-image"
            v-alt="user.username"
          />

          <div
            title="Add your profile Photo here"
            class="avatar-xs p-0 rounded-circle profile-photo-edit"
          >
            <input
              id="profile-img-file-input"
              type="file"
              @change="handleFiles"
              class="profile-img-file-input"
            />
            <label
              for="profile-img-file-input"
              class="profile-photo-edit avatar-xs"
            >
              <span class="avatar-title rounded-circle bg-light text-body">
                <i class="bx bxs-camera"></i>
              </span>
            </label>
          </div>
        </div>

        <h5 class="font-size-18 fw-bold mb-3 text-truncate">
          <div v-if="user.firstname || user.lastname">
            {{ user.firstname }} {{ user.lastname }}
          </div>
          <div v-else>
            {{ user.username }}
          </div>
        </h5>
        <!-- Descriptions -->
        <div class="px-3">
          <div
            v-if="user.jobtitle"
            class="small mb-1 text-start"
            title="Your Job title"
          >
            <i class="bx bxs-briefcase text-primary"></i>
            {{ user.jobtitle }}
          </div>
          <div
            v-if="user.organization"
            class="small mb-1 text-start"
            title="Your Organization"
          >
            <i class="bx bxs-home-heart text-primary"></i>
            {{ user.organization }}
          </div>
          <div class="small mb-1 text-start" title="You registered as:">
            <i class="bx bxs-user text-primary"></i>
            {{ user.roles }}
          </div>
        </div>
      </div>
      <!-- End profile user -->

      <!-- Start User profile description -->
      <div class="user-setting" data-simplebar>
        <div id="settingprofile" class="accordion accordion-flush">
          <div class="accordion-item text-dark">
            <div class="accordion-header" id="headerpersonalinfo">
              <button
                class="accordion-button font-size-16 fw-medium"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#personalinfo"
                aria-expanded="true"
                aria-controls="personalinfo"
              >
                <i class="bx bxs-edit text-primary me-3"></i>
                <span>Edit profile</span>
              </button>
            </div>
            <div
              id="personalinfo"
              class="accordion-collapse collapse show"
              aria-labelledby="headerpersonalinfo"
              data-bs-parent="#settingprofile"
            >
              <div class="accordion-body">
                <div class="mb-2">
                  <input
                    type="text"
                    class="form-control disabled"
                    id="username"
                    aria-describedby="emailHelp"
                    v-model="user.username"
                    disabled
                  />
                  <div id="emailHelp" class="form-text"></div>
                </div>

                <div class="form-floating mb-2">
                  <input
                    type="text"
                    class="form-control"
                    id="firstname"
                    aria-describedby="emailHelp"
                    v-model="user.firstname"
                    placeholder=" "
                  />
                  <label for="firstname">First name</label>
                </div>

                <div class="form-floating mb-2">
                  <input
                    type="text"
                    class="form-control"
                    id="lastname"
                    aria-describedby="emailHelp"
                    v-model="user.lastname"
                    placeholder=" "
                  />
                  <label for="lastname">Last name</label>
                </div>

                <div class="form-floating mb-2" v-if="user.roles == 'manager'">
                  <input
                    type="text"
                    class="form-control"
                    id="jobtitle"
                    aria-describedby="emailHelp"
                    v-model="user.jobtitle"
                    placeholder=" "
                  />
                  <label for="jobtitle">Job title</label>
                </div>

                <div class="form-floating mb-2" v-if="user.roles == 'manager'">
                  <input
                    type="text"
                    class="form-control"
                    id="organization"
                    aria-describedby="emailHelp"
                    v-model="user.organization"
                    placeholder=" "
                  />
                  <label for="organization">Organization</label>
                </div>

                <div class="form-floating mb-2">
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    aria-describedby="emailHelp"
                    v-model="user.email"
                    placeholder=" "
                  />
                  <label for="email">Email</label>
                </div>
                <hr />
                <div class="form-floating mb-2">
                  <div class="position-relative auth-pass-inputgroup mb-3">
                    <input
                      type="password"
                      class="form-control pe-5"
                      placeholder="Enter New Password"
                      id="password"
                      v-model="newPassword"
                      required
                    />
                    <button
                      class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                      type="button"
                      @click="$store.state.utils.switTypeInput"
                    >
                      <i class="ri-eye-fill align-middle"></i>
                    </button>
                  </div>
                </div>

                <div class="form-floating mb-2">
                  <input
                    type="password"
                    class="form-control"
                    id="replaypassword"
                    v-model="currentPassword"
                  />
                  <label for="replaypassword" class="form-label"
                    >Current Password</label
                  >
                </div>
                <div class="form-group">
                  <ul id="passwordHelp" class="form-text text-muted">
                    <li :class="has_lowercsae ? 'has_required' : ''">
                      one lowercase letter
                    </li>
                    <li :class="has_uppercase ? 'has_required' : ''">
                      one uppercase letter
                    </li>
                    <li :class="has_number ? 'has_required' : ''">
                      One number
                    </li>
                    <li :class="has_special ? 'has_required' : ''">
                      one special character.
                    </li>
                    <li :class="has_minimum_lenth ? 'has_required' : ''">
                      atleast 8 chacters
                    </li>
                  </ul>
                </div>

                <div class="form-floating mb-0 px-2">
                  <span
                    v-if="
                      passwordIsCorrect ||
                      nameIsCorrect ||
                      emailIsCorrect ||
                      imageCorrect
                    "
                    @click="submit"
                    class="btn-primary btn btn-sm"
                    title="Save"
                  >
                    <i class="fa-solid fa-floppy-disk align-middle"></i>
                  </span>
                  <span v-else class="text-light disabled" disabled>
                    <i class="fa-solid fa-floppy-disk align-middle"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- end personal info card -->

          <div class="accordion-item text-dark">
            <div class="accordion-header" id="headerhelp">
              <button
                class="accordion-button font-size-16 fw-medium collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapsehelp"
                aria-expanded="false"
                aria-controls="collapsehelp"
              >
                <i class="bx bxs-help-circle text-primary me-3"></i>
                <span>Help</span>
              </button>
            </div>
            <div
              id="collapsehelp"
              class="accordion-collapse collapse"
              aria-labelledby="headerhelp"
              data-bs-parent="#settingprofile"
            >
              <div class="accordion-body">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item py-3 px-0">
                    <h5 class="font-size-13 mb-0">
                      <router-link
                        :to="{ name: 'About' }"
                        custom
                        v-slot="{ navigate }"
                      >
                        <a
                          role="link"
                          title="Go to About us site"
                          class="text-primary text-decoration-none"
                          @click="navigate"
                          @keypress.enter="navigate"
                        >
                          About us
                          <i class="bx bx-link-external ms-2"></i>
                        </a>
                      </router-link>
                    </h5>
                  </li>
                  <li class="list-group-item py-3 px-0">
                    <h5 class="font-size-13 mb-0">
                      <router-link
                        :to="{ name: 'HowTo' }"
                        custom
                        v-slot="{ navigate }"
                      >
                        <a
                          role="link"
                          title="Go to How to use site"
                          class="text-primary text-decoration-none"
                          @click="navigate"
                          @keypress.enter="navigate"
                        >
                          How to use
                          <i class="bx bx-link-external ms-2"></i>
                        </a>
                      </router-link>
                    </h5>
                  </li>
                  <li class="list-group-item py-3 px-0">
                    <h5 class="font-size-13 mb-0">
                      <router-link
                        :to="{ name: 'Contact' }"
                        custom
                        v-slot="{ navigate }"
                      >
                        <a
                          role="link"
                          title="Go to Contact site"
                          class="text-primary text-decoration-none"
                          @click="navigate"
                          @keypress.enter="navigate"
                        >
                          Contact
                          <i class="bx bx-link-external ms-2"></i>
                        </a>
                      </router-link>
                    </h5>
                  </li>
                  <li class="list-group-item py-3 px-0 pb-0">
                    <h5 class="font-size-13 mb-0">
                      <router-link
                        :to="{ name: 'CookiesPolicy' }"
                        custom
                        v-slot="{ navigate }"
                      >
                        <a
                          role="link"
                          title="Go to Cookies Policy site"
                          class="text-primary text-decoration-none"
                          @click="navigate"
                          @keypress.enter="navigate"
                        >
                          Terms & Privacy policy
                          <i class="bx bx-link-external ms-2"></i>
                        </a>
                      </router-link>
                    </h5>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- end profile-setting-accordion -->
      </div>
      <!-- End User profile description -->
    </div>
    <!-- Start Settings content -->
  </div>
</template>

<script>
export default {
  name: "Setting",

  metaInfo() {
    return {
      title: "Setting",
      titleTemplate: "%s | NEW ABC APP",
    };
  },

  data() {
    return {
      user: undefined,
      mainEmail: "",
      mainUsername: "",
      mainProfileImage: "",

      currentPassword: "",
      newPassword: "",
      replaypassword: "",

      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_special: false,

      passwordIsCorrect: false,
      nameIsCorrect: false,
      emailIsCorrect: false,
      imageCorrect: false,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadData();
      // TODO: @muaz function to set edit button fixed position
      // document
      //   .querySelector(".editButton")
      //   .addEventListener("scroll", (event) => {
      //     console.log(event);
      //   });
    });
  },

  watch: {
    newPassword() {
      const val = this.$store.state.utils.filters.password(this.newPassword);

      this.has_minimum_lenth = val.has_minimum_lenth;
      this.has_number = val.has_number;
      this.has_lowercsae = val.has_lowercsae;
      this.has_uppercase = val.has_uppercase;
      this.has_special = val.has_special;

      this.passwordIsCorrect =
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth;
    },

    "user.username"() {
      const val = this.$store.state.utils.filters.name(this.user.username);

      this.nameIsCorrect =
        val.has_minimum_lenth &&
        val.only_letters &&
        val.is_mail &&
        this.mainUsername != this.user.username;
    },

    "user.firstname"() {
      if (!this.user.firstname) return;
      const val = this.$store.state.utils.filters.name(this.user.firstname);

      this.nameIsCorrect =
        val.has_minimum_lenth &&
        val.only_letters &&
        val.is_mail &&
        this.mainfirstname != this.user.firstname;
    },

    "user.lastname"() {
      if (!this.user.lastname) return;
      const val = this.$store.state.utils.filters.name(this.user.lastname);

      this.nameIsCorrect =
        val.has_minimum_lenth &&
        val.only_letters &&
        val.is_mail &&
        this.mainlastname != this.user.lastname;
    },

    "user.jobtitle"() {
      if (!this.user.jobtitle) return;
      const val = this.$store.state.utils.filters.name(this.user.jobtitle);

      this.nameIsCorrect =
        val.has_minimum_lenth &&
        val.only_letters &&
        val.is_mail &&
        this.mainjobtitle != this.user.jobtitle;
    },

    "user.organization"() {
      if (!this.user.organization) return;
      const val = this.$store.state.utils.filters.name(this.user.organization);

      this.nameIsCorrect =
        val.has_minimum_lenth &&
        val.only_letters &&
        val.is_mail &&
        this.mainorganization != this.user.organization;
    },

    "user.email"() {
      if (!this.user.email) return;
      const val =
        this.$store.state.utils.filters.validateEmail(this.user.email) &&
        this.mainEmail != this.user.email;

      this.emailIsCorrect = val;
    },

    "user.profile_image"() {
      if (this.user.profile_image != this.mainProfileImage) {
        this.imageCorrect = true;
      } else {
        this.imageCorrect = false;
      }
    },
  },

  methods: {
    loadData() {
      this.$store.state.modules.api
        .getUserByUsername(this.$store.state.modules.account.user.username)
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.utils.loaded = true;
            this.user = resp.data.user;
            this.mainEmail = this.$store.state.modules.account.user.email;
            this.mainUsername = this.$store.state.modules.account.user.username;
            this.mainProfileImage =
              this.$store.state.modules.account.user.profile_image;
          } else {
            this.user = this.$store.state.modules.account.user;
          }
        });
    },

    handleFiles(event) {
      this.getBase64(event.target.files[0]);
    },

    getBase64(file) {
      // TODO
      if (file.size < 2500000) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.user.profile_image = reader.result;
        };
        reader.onerror = (error) => {
          console.error("Error: ", error);
        };
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "max profile image is 250KB",
          },
          2500
        );
      }
    },

    submit() {
      event.preventDefault();

      let data = {
        email: this.user.email,
        username: this.user.username,
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        jobtitle: this.user.jobtitle,
        organization: this.user.organization,
        profile_image: this.user.profile_image,
      };

      if (this.newPassword.length > 7) {
        data.newPassword = this.newPassword;
        data.currentPassword = this.currentPassword;
      }

      this.$store.state.modules.api
        .updateProfile(data, JSON.parse(localStorage.account).token)
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.modules.account.user.email = this.user.email;
            this.$store.state.modules.account.user.username =
              this.user.username;
            this.$store.state.modules.account.user.profile_image =
              this.user.profile_image;

            this.mainEmail = this.user.email;
            this.mainUsername = this.user.username;
            this.mainProfileImage = this.user.profile_image;
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                message: "Success uploaded your setting",
              },
              2500
            );
          } else {
            this.user.email = this.mainEmail;
            this.user.username = this.mainUsername;
            this.user.profile_image = this.mainProfileImage;
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "Check the entries are correct",
              },
              2500
            );
          }
        });

      this.passwordIsCorrect = false;
      this.nameIsCorrect = false;
      this.emailIsCorrect = false;
      this.imageCorrect = false;
    },
  },
};
</script>

<style>
.accordion-body {
  position: relative;
}

.editButton {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
